// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2NnGM","head":"ProcedureTableInfo_head__2VGcN"};